import { Item } from 'shared-types';

export const removeBasketItem = <T extends Pick<Item, 'id' | 'dynamicPackage' | 'packageBasketItemId'>>(
  items: T[],
  itemId: string | number,
): T[] => {
  const target = items.find((item) => String(item.id) === String(itemId));
  if (!target) return items;
  if (target.dynamicPackage === 'parent') {
    return items.filter(
      (item) => String(item.id) !== String(itemId) && item.packageBasketItemId !== target.id,
    );
  }
  return items.filter((item) => String(item.id) !== String(itemId));
};
